/**
 * Local UI reducers for the Contacts / People screen.
 *
 * These manage component-level state (not Redux global store).
 * They live in lib/utils so that the screens/ folder stays
 * free of non-UI logic.
 */

import { CONTACTS_PAGE_SIZE } from "./contactConstants";

// ─── Groups ─────────────────────────────────────────────────────────────────

export const initialGroupsState = { list: [], loading: false };

export function groupsReducer(state, action) {
  switch (action.type) {
    case "FETCH_START":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return { list: action.payload, loading: false };
    case "FETCH_ERROR":
      return { ...state, loading: false };
    default:
      return state;
  }
}

// ─── People ─────────────────────────────────────────────────────────────────

export const initialPeopleState = {
  list: [],
  loading: false,
  page: 1,
  pageSize: CONTACTS_PAGE_SIZE,
  total: 0,
  query: "",
  searchInput: "",
};

export function peopleReducer(state, action) {
  switch (action.type) {
    case "FETCH_START":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return { ...state, list: action.list, total: action.total, loading: false };
    case "FETCH_ERROR":
      return { ...state, list: [], total: 0, loading: false };
    case "SET_PAGE":
      return { ...state, page: action.page };
    case "SET_PAGE_SIZE":
      return { ...state, pageSize: action.pageSize, page: 1 };
    case "SET_QUERY":
      return { ...state, query: action.query, page: 1 };
    case "SET_SEARCH_INPUT":
      return { ...state, searchInput: action.searchInput };
    case "RESET_QUERY":
      return { ...state, query: action.query, searchInput: action.query };
    default:
      return state;
  }
}
